class Menu {
  
  constructor() {
    this.burger = document.querySelector('.js-burger');
    this.menu = document.querySelector('.js-menu');
  }

  init() {
    
    this.burger.addEventListener('click', () => {
      this.burgerClick();
    });

  }

  burgerClick() {
    if ( this.burger.classList.contains('show') ) {
      this.hide( this.burger );
      this.hide( this.menu );
      this.hide( document.body );
    } else {
      this.show( this.burger );
      this.show( this.menu );
      this.show( document.body );
    }
  }

  /* eslint-disable */
  show( elem ) {
    if ( elem ) {
      elem.classList.add('show')
    }
  }

  hide( elem ) {
    if( elem ) {
      elem.classList.remove('show')
    }
  }
  /* eslint-enable */

}

export default Menu;
